import { render, staticRenderFns } from "./BankGroup.vue?vue&type=template&id=2a993afa"
import script from "./BankGroup.vue?vue&type=script&lang=js"
export * from "./BankGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports